import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Welcome To Sutuko Clinic',
  description: 'We provide quality medical care',
  keywords: 'drugs, customers, patients, medical tools',
};

export default Meta;
